
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/copyright/[slug]",
      function () {
        return require("private-next-pages/copyright/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/copyright/[slug]"])
      });
    }
  